import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import AnalyticsClient from '@st-graphics/backend/client/analytics'
import WindowProps from './plugins/WindowProps'
import HazeLanding from './components/HazeLanding.vue'

Vue.config.productionTip = false

Vue.use(VueCompositionApi)
Vue.use(WindowProps)
Vue.prototype.$analytics = new AnalyticsClient('haze-widget')

new Vue(HazeLanding).$mount('#app')
